import { type TSearchConfigAPIResponse } from '@atlassian/search-client/fetch-search-config';

/**
 * Checks if nouns are available for the given cloudId from site metadata.
 */
export const isNounsAvailable = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): boolean | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return false;
	}
	return firstPartyResponse.siteMetadata.find((metadata) => metadata.siteId === cloudId)
		?.isNounsAvailable;
};
